import { DateTime } from "luxon";

import { LocalTimeParser } from "../model/Common";
import { Shift } from "../model/EventSchedule";

import * as util from "../common/Util";

export interface ShiftRequest {
    beginTime: Date;
    endTime: Date;
    spotsToFill: number;
    locationId: number;
    positionId: number;
    recurrenceDates: Array<Date>;
    notes: string;
}

export const ShiftRequestFromShift = (shift: Shift): ShiftRequest => {
    return {
        beginTime: LocalTimeParser(shift.beginTime),
        endTime: LocalTimeParser(shift.endTime),
        spotsToFill: shift.spotsToFill,
        locationId: shift.location.id,
        positionId: shift.position.id,
        recurrenceDates: shift.recurrences.map(r => DateTime.fromISO(r.date).set({ hour: 12 }).toJSDate()),
        notes: shift.notes
    };
};

export const PreProcessShiftRequest = (raw: ShiftRequest): ShiftRequest => {
    const request = util.DeepCopy(raw);

    const beginTimeStr = DateTime.fromJSDate(raw.beginTime).toFormat("HH:mm");
    const endTimeStr = DateTime.fromJSDate(raw.endTime).toFormat("HH:mm");
    request.beginTime = DateTime.fromFormat(beginTimeStr, "HH:mm", { zone: "utc" }).toJSDate();
    request.endTime = DateTime.fromFormat(endTimeStr, "HH:mm", { zone: "utc" }).toJSDate();

    return request;
};
